export default __webpack_public_path__ + "static/media/sp1.d5928346.png";